// extracted by mini-css-extract-plugin
export default {"table":"TableCountries_table__P+1I8"};